import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient } from '@nike/fetch-client';
import getWebShellClientLocale from "../../../../../utils/get-webshellclient-locale";
import filterAndFormatParams from "../../../../../utils/filter-and-format-params";
import determineUserType from "../../../../../utils/determine-user-type";
/**
 *
 * @param {Object} param
 * @param {string} param.skuId - Sku identifier, unique UUID of the sku
 * @param {string} param.productId - Product identifier
 * @param {string} param.offeringTypes - List of fulfillment offering types to be included, SHIP, DIGITAL, PICKUP, INSTORE
 * @param {string} param.locationId - Location identifier, unique storeId or locationId REQUIRED IF OFFERING TYPE IS PICKUP
 * @param {string} param.locationType - it's required if locationId is present. Without the locationId, it can also be used to restrict PICKUP locations to a specific type. Allowed values: store/store_views, ship/pickup_points
 * @param {Object} param.currency
 * @returns {Promise} - Returns a promise that resolves to the fulfillment offerings for a given sku
 */

var fetchFulfillmentOfferings = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _getWebShellClientLoc;
    var skuId, productId, postalCode, locationId, offeringTypes, locationType, currency, countryCode, userType, resolvedSkuId, resolvedProductId, filters, qs;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          skuId = _ref.skuId, productId = _ref.productId, postalCode = _ref.postalCode, locationId = _ref.locationId, offeringTypes = _ref.offeringTypes, locationType = _ref.locationType, currency = _ref.currency;
          countryCode = (_getWebShellClientLoc = getWebShellClientLocale()) === null || _getWebShellClientLoc === void 0 || (_getWebShellClientLoc = _getWebShellClientLoc.country) === null || _getWebShellClientLoc === void 0 ? void 0 : _getWebShellClientLoc.toUpperCase();
          /* istanbul ignore next */
          _context.next = 1;
          return determineUserType();
        case 1:
          userType = _context.sent;
          resolvedSkuId = skuId || undefined;
          resolvedProductId = resolvedSkuId ? undefined : productId;
          filters = [{
            countryCode: countryCode
          }, {
            postalCode: postalCode
          }, {
            currency: currency
          }, {
            skuId: resolvedSkuId
          }, {
            productId: resolvedProductId
          }, {
            locationId: locationId
          }, {
            offeringTypes: offeringTypes
          }, {
            locationType: locationType
          }, {
            userType: userType
          }];
          qs = filterAndFormatParams(filters);
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/fulfillment_offerings/v1?").concat(qs)));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchFulfillmentOfferings(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default fetchFulfillmentOfferings;